import request from '@/utils/request'


// 查询物流公司信息列表
export function listLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/list',
    method: 'post',
    data: data
  })
}

// 查询物流公司信息分页
export function pageLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/page',
    method: 'post',
    data: data
  })
}

// 查询物流公司信息详细
export function getLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/detail',
    method: 'post',
    data: data
  })
}

// 新增物流公司信息
export function addLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/add',
    method: 'post',
    data: data
  })
}

// 修改物流公司信息
export function updateLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/edit',
    method: 'post',
    data: data
  })
}

// 删除物流公司信息
export function delLogistics(data) {
  return request({
    url: '/biz/admin/order/logistics/delete',
    method: 'post',
    data: data
  })
}
